module.exports = __webpack_public_path__ + "static/media/plus-white-icon.bddd1d90.svg";